import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { APP_ROUTES } from '../config/appRoutes';
import { supabase } from '../lib/supabase';

export default function GlobalNavigationMenu() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleNavigate = (path) => {
    navigate(path);
    setIsOpen(false);
  };

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleLogout = async () => {
    setIsOpen(false);
    try {
      await supabase?.auth?.signOut();
    } catch (e) {
      // silent
    }
    navigate('/dashboard');
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef?.current && !dropdownRef?.current?.contains(event?.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div ref={dropdownRef} className="relative inline-block">
      {/* Icon Button */}
      <button
        type="button"
        onClick={handleToggle}
        className="flex items-center justify-center w-10 h-10 bg-white text-gray-700 rounded-lg shadow-sm hover:shadow-md hover:bg-gray-50 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1"
        aria-label="Menu de Navegação"
        aria-expanded={isOpen}
        aria-haspopup="true"
        title="Atalhos entre Ferramentas"
      >
        <Menu className="w-5 h-5" />
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className="absolute top-12 left-0 bg-white rounded-lg shadow-xl border border-gray-200 overflow-visible animate-fadeIn z-50" style={{ minWidth: '220px', width: 'max-content', maxWidth: '340px' }}>
          <div className="py-2">
            {APP_ROUTES?.filter((route) => {
              // Hide "Atendimento Premium" when already on that page
              if (route?.path === '/atendimento-premium' && location?.pathname === '/atendimento-premium') {
                return false;
              }
              return true;
            })?.map((route) => {
              const isActive = location?.pathname === route?.path;
              return (
                <button
                  key={route?.path}
                  type="button"
                  onClick={() => handleNavigate(route?.path)}
                  className={`w-full text-left px-4 py-3 text-sm transition-colors duration-150 ${
                    isActive
                      ? 'bg-blue-50 text-blue-700 font-semibold border-l-4 border-blue-600' :'text-gray-700 hover:bg-blue-50 hover:text-blue-600 border-l-4 border-transparent'
                  }`}
                  style={{ whiteSpace: 'nowrap' }}
                >
                  {route?.label}
                </button>
              );
            })}
            {/* Divider */}
            <div className="border-t border-gray-100 my-1" />
            {/* Sair - always last */}
            <button
              type="button"
              onClick={handleLogout}
              className="w-full text-left px-4 py-3 text-sm transition-colors duration-150 text-red-600 hover:bg-red-50 border-l-4 border-transparent hover:border-red-400 font-medium whitespace-nowrap"
            >
              Sair
            </button>
          </div>
        </div>
      )}
    </div>
  );
}